<template>
    <van-popup v-model="showCalendar" round position="bottom">
      <div class="pop-title">
        <i class="close-icon" @click="showPicker = false"></i>
        <p>{{title}}</p>
        <i class="confirm-icon" @click="done()"></i>
      </div>
      <div style="display: flex;align-items: center">
        <van-datetime-picker v-model="currentDate" :show-toolbar="false" style="flex: 1" @cancel="showCalendar = false" type="date" title="选择开始时间" @change="onConfirm" />
        <van-picker :show-toolbar="false" style="flex: .3" :columns="columns" @change="onChange" />
      </div>
    </van-popup>
</template>

<script>
export default {
  props:{
    title:{
      type: String,
      default: '请选择'
    },
    minDate:{
      type: Date,
      default: ()=> new Date()
    },
    maxDate:{
      type: Date,
      default: ()=> new Date()
    }
  },
  data(){
    return {
      showCalendar: false,
      columns: ['上午', '下午'],
      currentDate: new Date(),
      date: new Date().format('yyyy-MM-dd'),
      time: '上午'
    }
  },
  methods:{
    onChange(picker, value, index) {
      this.time = value
    },
    onConfirm(picker) {
      // console.log(picker.getValues())
      this.date = picker.getValues().join('-')
    },
    done(){
      this.showCalendar = false
      this.$emit('done', `${this.date} ${this.time}`)
      // console.log(`${this.date} ${this.time}`)
    }
  }
}
</script>

<style lang="less" scoped>
.close-icon {
  background: url(../../../../../../static/img/close.png) no-repeat center;
}
.pop-title {
  display: flex;
  justify-content: space-between;
  padding: 13px;
  position: fixed;
  width: 100%;
  background-color: @attendance-color-3;
  box-sizing: border-box;
  border-radius: 5px 5px 0 0;
  z-index: 9;
}
.pop-title i {
  width: 22px;
  height: 22px;
  background-size: 22px 22px;
}
.confirm-icon {
  background: url(../../../../../../static/img/confirm.png) no-repeat center;
}
</style>


// WEBPACK FOOTER //
// src/components/newPages/student/internship/components/dateTimePicker.vue